import { useQuery } from '@tanstack/react-query'
import { apiV1 } from '@/shared/api/apiPrefix'
import { httpClient } from '@/shared/lib/httpClient'
import { usePortalSessionEstablished } from '@/shared/api/brandQueries'
import { pollInterval } from '@/shared/lib/rateLimit'

export type ImpersonationStatus = {
  active: boolean
  started_at: string | null
  elapsed_seconds: number
  heartbeat_seconds: number
  admin_url: string
  reason: string | null
}

export const impersonationKeys = {
  status: ['auth', 'impersonation', 'status'] as const,
}

export function impersonationPollInterval(
  data: Pick<ImpersonationStatus, 'active' | 'heartbeat_seconds'> | undefined,
  error?: unknown,
): number | false {
  if (data?.active !== true) return false

  return pollInterval(Math.max(5, data.heartbeat_seconds) * 1000, error)
}

export function useImpersonationStatusQuery(enabled = true) {
  const portalSession = usePortalSessionEstablished()
  const sessionReady = portalSession.data === true

  return useQuery({
    queryKey: impersonationKeys.status,
    enabled: enabled && sessionReady,
    queryFn: async (): Promise<ImpersonationStatus> => {
      const res = await httpClient.get<{ data: ImpersonationStatus }>(apiV1('/auth/impersonation'))
      return res.data.data
    },
    refetchInterval: (query) => impersonationPollInterval(query.state.data, query.state.error),
  })
}
